import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import ListInvalidDocumentBloc from "../blocs/espace-document/ListInvalidDocumentBloc";
import useAppState from "../context/AppContext";

export default function ListInvalidDocumentPage() {

  const {
    state: { isConseiller }
  } = useAppState();
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
     
      <div className="entreprise-container">
        <h1 className="title ml-lg-desktop mb-sm">{isConseiller ? 'Justificatifs' :'Mes justificatifs'}</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg  m-lg-desktop">
            <ListInvalidDocumentBloc  />
        </div>
      </div>
 
    )
}